import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import InOutHistoryUserUnregisteredContext from './InOutHistoryUserUnregisteredContext';
import InOutHistoryUserUnregisteredApi from './InOutHistoryUserUnregisteredApi';
import InOutHistoryUserUnregisteredService from './InOutHistoryUserUnregisteredService';

import SessionStorageService from '../utilities/SessionStorageService';
import { messageUtility } from '../../utilities/messageUtility';
import DocumentDelegate from '../../utilities/DocumentDelegate';
import { DropdownCalendarLoader } from '../../utilities/formComponents';
import { isNullOrEmpty } from '../../utilities/stringUtil';
import {
  blobToJsonConversion,
  extractErrorMessage,
} from '../../utilities/commonUtil';
import {
  DATE_TIME_FORMAT,
  SORT_TYPE,
  ENTRANCE_WORKER_TYPES,
  DIALOG_STATUS,
  UNIDENTIFIED_LOGS_AUTO_SEND,
  UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED,
  SEARCH_CCUS_SENT_STATUS,
} from '../../utilities/constants';

/**
 * 不明な入退場データ画面のstate管理用コンポーネント
 * */
export default class InOutHistoryUserUnregisteredStore extends React.Component {
  state = {
    isLoading: true, // API等でローディング中フラグ
    canLoadMore: true,
    isShowNotExistFieldIdDialog: false, // 現場IDの存在チェックフラグ
    isReflectErrorDialog: false, // 実績反映エラーメッセージダイアログ表示フラグ
    isCsvExportErrorDialog: false, // CSV出力エラーメッセージダイアログ表示フラグ
    reflectErrorMessage: '', // 実績反映エラーメッセージ
    csvExportErrorMessage: '', // CSV出力エラーメッセージ
    reflectFailedByAlreadyRegisteredError: {
      // CCUSにすでに送信済みによる実績反映エラー
      showDialog: false,
      reqLogsLength: 0, // 実績反映を依頼した不明な入退場データの数
      errLogs: [], // 実績反映に失敗した不明な入退場データと入退場データのペア
    },
    unidentifiedLogs: [], // 不明な入退場データ一覧
    reflectionUnidentifiedLogList: [], // 実績反映する不明な入退場データ一覧
    reflectionFieldWorkerTreeList: [], // 不明な入退場IDに紐づくfieldTreeのリスト
    reflectionFieldSpotWorkerList: [], // 現場ゲストのリスト
    unidentifiedLogsAutoSendFlg: UNIDENTIFIED_LOGS_AUTO_SEND.OFF, // 不明な入退場データのCCUS送信設定
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示ステータス
    fieldId: '',
    informationModal: {
      title: null, // モーダルダイアログのタイトル
      message: null, // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
      multilineText: false, // モーダルダイアログメッセージには複数の行がある場合
    },
    searchForm: {
      // 検索フォーム用プロパティ
      total: 0, // 検索結果件数
      offset: 0, // 検索時の初期件数
      order: '', // ソート項目
      sortType: '',
      // @TODO: 2019/12月リリース時点では検索機能には対応しない
      // selectedRegisterCcusEngineerType: '', // 作業員登録区分 (0:未登録、1:登録済み)
      // workerName: '', // 作業員名
      // ccusEngineerId: '', // CCUS技能者ID
      // selectedInOutType: '', // 入退場種別 (0:区別なし、1:入場、2:退場)
      fromDate: '', // 期間開始日
      toDate: '', // 期間終了日
      isOpened: false, // 検索フォームトグルの開閉フラグ
      selectedSentStatus: '', // 送信状態
      priorCcusError: false,
    },
    currentSearchParams: {
      fromDate: '', // 期間開始日
      toDate: '', // 期間終了日
      selectedSentStatus: '', // 送信状態
      priorCcusError: false,
    }, // 表示中の検索条件
    deleteItem: {
      // 削除しようとしているデータ
      id: '', // 選択中のID
      workerType: '', // 入退場者種別
      ccusEngineerId: '', // CCUS技能者ID
      workerName: '', // 作業員名
      fullCompanyNames: '', // 会社名
      recordDateAt: '', // レコード日時
      inOutType: '', // 入退場種別 (0:区別なし、 1:入場、 2:退場)
    },
    failDialog: {
      message: '',
      title: '',
    },
  };

  /**
   * 現場情報が存在しないエラーダイアログを閉じる
   * */
  closeNotExistFieldIdDialog = () => {
    let state = { ...this.state };
    state.isShowNotExistFieldIdDialog = false;
    this.setState(state);
  };

  /**
   * ダイアログをクローズする
   * */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = null;
    state.informationModal.buttonText = null;
    state.informationModal.multilineText = false;
    this.setState(state);
  };

  /**
   * APIのエラーメッセージダイアログを表示する
   * @param {object} response レスポンスデータ
   * */
  showErrorMessageDialog = (state, response) => {
    state.dialogStatus = DIALOG_STATUS.otherErrorDialogEnabled.id;
    state.informationModal.title = null;
    state.informationModal.message = extractErrorMessage(response);
    state.informationModal.buttonText = messageUtility.getMessage('I-000-008');
    return state;
  };

  // @TODO: 2019/12月リリース時点では検索機能には対応しない
  //
  // /**
  //  * 検索フォームのCCUS技能者IDを入力
  //  * @param {object}event:入力されたCCUS技能者ID
  //  * */
  // inputCcusEngineerId = event => {
  //   let state = { ...this.state };
  //   state[event.target.name].ccusEngineerId = event.target.value;
  //   this.setState(state);
  // };
  //
  // /**
  //  * 検索フォームのCCUS技能者IDで検索
  //  * */
  // searchCcusEngineerId = () => {
  //   let state = { ...this.state };
  //   state = this.clearListInfo(state);
  //   this.setState(state);
  //   this.loadUnidentifiedLogsList();
  // };
  //
  // /**
  //  * 検索フォームの作業員名を入力
  //  * @param {object}event:入力された作業員名
  //  * */
  // inputWorkerName = event => {
  //   let state = { ...this.state };
  //   state[event.target.name].workerName = event.target.value;
  //   this.setState(state);
  // };
  //
  // /**
  //  * 検索フォームの作業員名で検索
  //  * */
  // searchWorkerName = () => {
  //   let state = { ...this.state };
  //   state = this.clearListInfo(state);
  //   this.setState(state);
  //   this.loadUnidentifiedLogsList();
  // };
  //
  // /**
  //  * 検索フォームの作業員登録区分を選択
  //  * @param {object}event:選択された作業員登録区分
  //  * */
  // selectedRegisterCcusEngineerType = event => {
  //   let state = { ...this.state };
  //   state[event.target.name].selectedRegisterCcusEngineerType =
  //     event.target.value;
  //   state = this.clearListInfo(state);
  //   this.setState(state);
  //   this.loadUnidentifiedLogsList();
  // };
  //
  // /**
  //  * 検索フォームの入退場種別を選択
  //  * @param {object}event:選択された入退場種別
  //  * */
  // selectedInOutType = event => {
  //   let state = { ...this.state };
  //   state[event.target.name].selectedInOutType = event.target.value;
  //   state = this.clearListInfo(state);
  //   this.setState(state);
  //   this.loadUnidentifiedLogsList();
  // };
  //

  /**
   * 検索フォームの開閉トグル
   * @param {string}propertyName:ステート内のプロパティ名
   * */
  searchFormHandle = propertyName => {
    let state = _.cloneDeep(this.state);
    state[propertyName].isOpened = !state[propertyName].isOpened;
    this.setState(state);
  };

  /**
   * 検索条件をクリアする
   * @param {string}propertyName:ステート内のプロパティ名
   * */
  clearSearchProperty = propertyName => {
    let state = _.cloneDeep(this.state);
    state[propertyName].priorCcusError = false;
    state[propertyName].selectedSentStatus = '';
    state[propertyName].order = '';
    state[propertyName].sortType = '';
    state[propertyName].fromDate = '';
    state[propertyName].toDate = '';
    state = this.clearListInfo(state);
    state.currentSearchParams = {
      fromDate: '',
      toDate: '',
      selectedSentStatus: '',
      priorCcusError: false,
    };
    this.setState(state, () => {
      this.loadUnidentifiedLogsList();
    });
  };

  /**
   * 検索フォームの送信状態を選択
   * @param {object}event:選択された送信状態
   * */
  selectedSentStatus = event => {
    const state = _.cloneDeep(this.state);
    state[event.target.name].selectedSentStatus = event.target.value;
    this.setState(state);
  };

  /**
   * 検索フォームのCCUSエラーを優先するフラグのトグル
   * @param {string}} priorCcusError 選択された値
   * */
  selectedPriorCcusError = priorCcusError => {
    const state = _.cloneDeep(this.state);
    state.searchForm.priorCcusError = priorCcusError;
    this.setState(state);
  };

  /**
   * @description 期間設定
   * @param {string} name フォーム名
   * @param {string} value 選択期間
   */
  changeSearchDate = (name, value) => {
    let state = { ...this.state };
    state.searchForm[name] = moment(value).format(
      DATE_TIME_FORMAT.slashDateFormat
    );

    if (name === 'fromDate') {
      if (moment(state.searchForm.fromDate).isAfter(state.searchForm.toDate)) {
        state.searchForm.toDate = moment(state.searchForm.fromDate).format(
          DATE_TIME_FORMAT.slashDateFormat
        );
      }
    } else if (name === 'toDate') {
      if (moment(state.searchForm.fromDate).isAfter(state.searchForm.toDate)) {
        state.searchForm.fromDate = moment(state.searchForm.toDate).format(
          DATE_TIME_FORMAT.slashDateFormat
        );
      }
    }
    this.setState(state);
  };

  /**
   * 検索
   */
  doSearch = () => {
    let state = _.cloneDeep(this.state);
    state = this.clearListInfo(state);
    state.currentSearchParams = {
      fromDate: state.searchForm.fromDate,
      toDate: state.searchForm.toDate,
      selectedSentStatus: state.searchForm.selectedSentStatus,
      priorCcusError: state.searchForm.priorCcusError,
    };
    this.setState(state, () => {
      this.loadUnidentifiedLogsList();
    });
  };

  /**
   * チェックボックス1件更新
   * @param {object}item:1件のオブジェクト(選択した不明な入退場データ)
   * */
  checkReflectionData = item => {
    if (!item.hasOwnProperty('id')) {
      return;
    }

    let state = { ...this.state };
    if (state.reflectionUnidentifiedLogList.length > 0) {
      if (_.includes(state.reflectionUnidentifiedLogList, item)) {
        _.pull(state.reflectionUnidentifiedLogList, item);
      } else {
        state.reflectionUnidentifiedLogList.push(item);
      }
    } else {
      state.reflectionUnidentifiedLogList.push(item);
    }
    this.setState(state);
  };

  /**
   * 協力会社を変更
   * @param {object}item:1件のオブジェクト(選択した不明な入退場データ)
   * @param {string}fieldTreeWorkerId:1件のオブジェクト(選択した協力会社ID)
   * */
  changeFieldWorkerTree = (item, fieldTreeWorkerId) => {
    if (!item.hasOwnProperty('id')) {
      return;
    }

    let state = { ...this.state };
    _.map(state.reflectionFieldWorkerTreeList, it => {
      if (it.id === item.id) {
        it.fieldTreeWorkerId = Number(fieldTreeWorkerId);
      }
    });
    this.setState(state);
  };

  /**
   * ソート
   * @param {string}sortName:ソートしたい名前
   * */
  changeSort = sortName => {
    let state = { ...this.state };
    state = this.clearListInfo(state);
    if (state.searchForm.sortType === SORT_TYPE.asc.id) {
      state.searchForm.sortType = SORT_TYPE.desc.id;
    } else {
      state.searchForm.sortType = SORT_TYPE.asc.id;
    }

    if (state.searchForm.order !== sortName) {
      state.searchForm.order = sortName;
      state.searchForm.sortType = SORT_TYPE.asc.id;
    }
    this.setState(state, () => {
      this.loadUnidentifiedLogsList();
    });
  };

  /**
   * 削除ダイアログを表示する為のデータを格納
   * @param {object}item:ステート内のプロパティ名
   * */
  selectedDeleteItem = item => {
    if (!item.hasOwnProperty('id')) {
      return;
    }

    /**
     * 選択した削除項目から会社名の配列を取得する
     * BLDE_V2-47431
     * @param {Object} item - 選択した削除項目
     * @returns {string[]} - 会社名の配列（企業名が見つからない場合は空の配列）
     */
    const getCompanyNames = item => {
      const names = [];
      if (!isNullOrEmpty(item.field_tree_workers)) {
        // 作業員が施工体制に紐づいてる協力会社がある場合、全会社の会社名を配列として取得する
        item.field_tree_workers.map(company =>
          names.push(company.full_company_name)
        );
      } else if (!isNullOrEmpty(item.field_spot_workers)) {
        // ゲスト常駐社員・非常駐入退場者として登録されてた場合、その会社名を取得する
        names.push(item.field_spot_workers[0].full_company_name);
      } else if (item.company_name) {
        // 上記以外でも会社名が取得されてる場合、その会社名を表示する
        names.push(item.company_name);
      }
      return names;
    };

    let state = { ...this.state };
    state.deleteItem.id = item.id;
    state.deleteItem.workerType = !_.isNil(item.worker_type)
      ? ENTRANCE_WORKER_TYPES[
          Object.keys(ENTRANCE_WORKER_TYPES).find(
            worker_type =>
              ENTRANCE_WORKER_TYPES[worker_type].id === item.worker_type
          )
        ].name
      : '';
    state.deleteItem.ccusEngineerId = item.ccus_engineer_id;
    state.deleteItem.workerName = item.name_sei + item.name_mei;
    state.deleteItem.fullCompanyNames = getCompanyNames(item);
    state.deleteItem.recordDateAt = moment(
      new Date(item.record_date_at).toISOString()
    ).format(DATE_TIME_FORMAT.slashDateTimeFormat);
    state.deleteItem.inOutType = item.in_out_type;
    this.setState(state);
  };

  /**
   * 削除ダイアログを表示する為のデータを初期化
   * */
  clearDeleteItem = () => {
    let state = { ...this.state };
    state.deleteItem.id = '';
    state.deleteItem.ccusEngineerId = '';
    state.deleteItem.workerType = '';
    state.deleteItem.workerName = '';
    state.deleteItem.fullCompanyNames = '';
    state.deleteItem.recordDateAt = '';
    state.deleteItem.inOutType = '';
    this.setState(state);
  };

  /**
   * 実績反映エラーの時にメッセージダイアログを表示
   * @param {object}state
   * @param {string}message:エラーメッセージ
   * */
  showReflectErrorDialog = (state, message) => {
    state.isReflectErrorDialog = true;
    state.reflectErrorMessage = message;
  };

  /**
   * 実績反映エラーメッセージダイアログを閉じる
   * */
  closeReflectErrorDialog = () => {
    let state = { ...this.state };
    state.isReflectErrorDialog = false;
    state.reflectErrorMessage = '';
    this.setState(state);
  };

  /**
   * CSV出力エラーメッセージダイアログを閉じる
   * */
  closeCsvExportErrorDialog = () => {
    let state = { ...this.state };
    state.isCsvExportErrorDialog = false;
    this.setState(state);
  };

  /**
   * CCUSにすでに送信済みによる実績反映エラーの時にメッセージダイアログを表示
   * @param {object}state
   * @param {any[]}reqLogs:実績反映を依頼した不明な入退場データ
   * @param {any[]}errLogs:実績反映に失敗した不明な入退場データと入退場データのペア
   * */
  showReflectFailedByAlreadyRegisteredErrorDialog = (
    state,
    reqLogs = [],
    errLogs = []
  ) => {
    state.reflectFailedByAlreadyRegisteredError = {
      showDialog: true,
      reqLogsLength: reqLogs.length,
      errLogs,
    };
  };

  /**
   * CCUSにすでに送信済みによる実績反映エラーメッセージダイアログを閉じる
   * */
  closeReflectFailedByAlreadyRegisteredErrorDialog = () => {
    let state = { ...this.state };
    state.reflectFailedByAlreadyRegisteredError = {
      showDialog: false,
      reqLogsLength: 0,
      errLogs: [],
    };
    this.setState(state);
  };

  /**
   * 不明な入退場リストを初期化する
   * @param {object}state
   * */
  clearListInfo = state => {
    state.searchForm.total = 0;
    state.searchForm.offset = 0;
    state.unidentifiedLogs.length = 0;
    state.reflectionUnidentifiedLogList.length = 0;
    state.reflectionFieldWorkerTreeList.length = 0;
    state.reflectionFieldSpotWorkerList.length = 0;
    state.canLoadMore = true;
    return state;
  };

  /**
   * 無限スクロールから呼び出される
   * @param {function}notify
   * */
  infiniteScrollLoad = notify => {
    let state = { ...this.state };
    if (state.isLoading && notify) {
      notify();
      return;
    }

    if (state.canLoadMore) {
      this.loadUnidentifiedLogsList();
    }
    if (notify) {
      notify(state.canLoadMore ? undefined : 'end');
    }
  };

  /**
   * 不明な入退場一覧を取得する
   * */
  loadUnidentifiedLogsList = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state, () => {
      const params = {
        ...state.searchForm,
        ...state.currentSearchParams,
      };
      InOutHistoryUserUnregisteredApi.fetchUnidentifiedLogs(
        SessionStorageService.getFieldId(),
        InOutHistoryUserUnregisteredService.createSearchUnidentifiedLogParam(
          params
        )
      )
        .then(response => {
          if (response.result) {
            state.searchForm.total = response.data.total;
            state.unidentifiedLogsAutoSendFlg =
              response.data.unidentified_logs_auto_send_flg;
            response.data.entities.unidentified_logs.map(it => {
              state.unidentifiedLogs.push(it);

              if (!isNullOrEmpty(it.field_tree_workers)) {
                state.reflectionUnidentifiedLogList.push(it);
                state.reflectionFieldWorkerTreeList.push({
                  id: it.id,
                  fieldTreeWorkerId:
                    it.field_tree_workers[0].field_tree_worker_id,
                });
              }
              if (
                !isNullOrEmpty(it.field_spot_workers) &&
                !isNullOrEmpty(
                  it.field_spot_workers.find(
                    fsp => !isNullOrEmpty(fsp.field_spot_worker_id)
                  )
                )
              ) {
                state.reflectionUnidentifiedLogList.push(it);
                state.reflectionFieldSpotWorkerList.push({
                  id: it.id,
                  fieldSpotWorkerId:
                    it.field_spot_workers[0].field_spot_worker_id,
                });
              }
            });
            if (state.unidentifiedLogs.length > 0) {
              state.searchForm.offset = state.unidentifiedLogs.length;
            }
          } else {
            state = this.showErrorMessageDialog(state, response);
          }
        })
        .catch(error => {
          state = this.showErrorMessageDialog(state, error);
        })
        .finally(() => {
          const { unidentifiedLogs, searchForm } = state;
          state.isLoading = false;
          state.canLoadMore = _.size(unidentifiedLogs) < searchForm.total;
          this.setState(state);
        });
    });
  };

  /**
   * 不明な入退場データを実績反映する
   * */
  updateUnidentifiedLog = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state, () => {
      InOutHistoryUserUnregisteredApi.updateUnidentifiedLogs(
        SessionStorageService.getFieldId(),
        InOutHistoryUserUnregisteredService.createUpdateUnidentifiedLogParam(
          state.reflectionFieldWorkerTreeList,
          state.reflectionUnidentifiedLogList,
          state.reflectionFieldSpotWorkerList
        )
      )
        .then(response => {
          if (response.result) {
            state.isLoading = false;
            this.clearListInfo(state);
            this.setState(state, () => {
              this.loadUnidentifiedLogsList();
            });
          } else {
            state.isLoading = false;
            const responseMessage = response.data.message || response.message;
            // APIからエラーメッセージが返してきた場合
            if (!isNullOrEmpty(responseMessage)) {
              // エラーダイアログ表示
              this.showReflectErrorDialog(state, responseMessage);
              // 一覧をリロード
              this.clearListInfo(state);
              this.setState(state, () => {
                this.loadUnidentifiedLogsList();
              });
            } else if (
              !isNullOrEmpty(response.data.entities.already_registered_logs) &&
              response.data.entities.already_registered_logs.length > 0
            ) {
              const errLogs = response.data.entities.already_registered_logs;
              const reqParam = InOutHistoryUserUnregisteredService.createUpdateUnidentifiedLogParam(
                state.reflectionFieldWorkerTreeList,
                state.reflectionUnidentifiedLogList,
                state.reflectionFieldSpotWorkerList
              );
              const reqLogs = reqParam.unidentified_logs;
              this.showReflectFailedByAlreadyRegisteredErrorDialog(
                state,
                reqLogs,
                errLogs
              );
              this.clearListInfo(state);
              this.setState(state, () => {
                this.loadUnidentifiedLogsList();
              });
            } else if (
              !isNullOrEmpty(response.data.entities.un_successful_requests) &&
              response.data.entities.un_successful_requests.length > 0
            ) {
              this.showReflectErrorDialog(
                state,
                messageUtility.getMessage(
                  'E-002-007-01',
                  response.data.entities.un_successful_requests.length
                )
              );
              this.clearListInfo(state);
              this.setState(state, () => {
                this.loadUnidentifiedLogsList();
              });
            }
          }
        })
        .catch(error => {
          state = this.showErrorMessageDialog(state, error);
          state.isLoading = false;
          this.setState(state);
        });
    });
  };

  /**
   * 施工体系選択イベント
   * @param {object}fieldTreeIds
   * */
  // selectFieldTree = fieldTreeIds => {
  //   let state = { ...this.state };
  //   state.searchForm.fieldTreeIds = fieldTreeIds;
  //   this.setState(state);
  // };

  /**
   * 不明な入退場データを削除する
   * */
  deleteUnidentifiedLog = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state, () => {
      InOutHistoryUserUnregisteredApi.deleteUnidentifiedLogs(
        SessionStorageService.getFieldId(),
        state.deleteItem.id
      )
        .then(response => {
          if (response.result) {
            state.isLoading = false;
            this.clearListInfo(state);
            this.setState(state, () => {
              this.clearDeleteItem();
              this.loadUnidentifiedLogsList();
            });
          } else {
            this.clearDeleteItem();
            state = this.showErrorMessageDialog(state, response);
            state.isLoading = false;
            this.setState(state);
          }
        })
        .catch(error => {
          this.clearDeleteItem();
          state = this.showErrorMessageDialog(state, error);
          state.isLoading = false;
          this.setState(state);
        });
    });
  };

  /**
   * 不明な入退場データCSV出力
   * */
  downloadUnidentifiedLogsCsv = () => {
    const state = _.cloneDeep(this.state);
    const param = Object.create(null);
    const fieldId = SessionStorageService.getFieldId();
    param.record_date_from = state.currentSearchParams.fromDate;
    param.record_date_to = state.currentSearchParams.toDate;
    // ソート状態を反映
    if (!_.isEmpty(state.searchForm.order)) {
      if (state.searchForm.sortType === SORT_TYPE.asc.id) {
        param.order = state.searchForm.order + SORT_TYPE.asc.name;
      } else {
        param.order = state.searchForm.order + SORT_TYPE.desc.name;
      }
    }
    // 検索条件の「送信状態」を反映
    if (!_.isEmpty(state.currentSearchParams.selectedSentStatus)) {
      const selectedSentStatusArray = [];
      switch (Number(state.currentSearchParams.selectedSentStatus)) {
        case UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED.UNSENT.ID:
          // 未送信 (変更未送信、送信中、変更送信中も含む)
          selectedSentStatusArray.push(
            SEARCH_CCUS_SENT_STATUS.unsent.id,
            SEARCH_CCUS_SENT_STATUS.notSentAfterChange.id,
            SEARCH_CCUS_SENT_STATUS.sending.id,
            SEARCH_CCUS_SENT_STATUS.sendingAfterChange.id
          );
          break;
        case UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED.EXEMPT.ID:
          // 対象外
          selectedSentStatusArray.push(SEARCH_CCUS_SENT_STATUS.exempt.id);
          break;
        case UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED.SENT.ID:
          // 送信済
          selectedSentStatusArray.push(SEARCH_CCUS_SENT_STATUS.sent.id);
          break;
        case UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED.SENDING_ERROR.ID:
          // 送信エラー
          selectedSentStatusArray.push(SEARCH_CCUS_SENT_STATUS.sendingError.id);
          break;
        default:
          break;
      }
      param.ccus_send_status = selectedSentStatusArray;
    }
    param.priorCcusError = state.currentSearchParams.priorCcusError;
    if (state.isLoading) {
      return;
    }
    // 3000件以上の場合エラーメッセージを表示
    if (state.searchForm.total > data.CSV_EXPORT_LIMIT) {
      this.setState({ isCsvExportErrorDialog: true });
      return;
    }
    this.setState({ isLoading: true }, () => {
      InOutHistoryUserUnregisteredApi.fetchUnidentifiedLogsCSV(fieldId, param)
        .then(result => {
          if (result instanceof Blob) {
            InOutHistoryUserUnregisteredService.downloadCsv(result, fieldId);
          } else {
            blobToJsonConversion(result.data)
              .then(blob => {
                state.failDialog.message = blob.message;
                state.errorDialogStatus =
                  DIALOG_STATUS.downloadUnidentifiedLogsCsvFailDialogEnabled.id;
              })
              .catch(() => {
                state.failDialog.message = messageUtility.getMessage(
                  'E-000-021'
                );
                state.errorDialogStatus =
                  DIALOG_STATUS.downloadUnidentifiedLogsCsvFailDialogEnabled.id;
              })
              .finally(() => {
                this.setState(state);
              });
          }
        })
        .catch(error => {
          state.failDialog.message = extractErrorMessage(error);
          state.errorDialogStatus =
            DIALOG_STATUS.downloadInOutResultCsvFailDialogEnabled.id;
        })
        .finally(() => {
          state.isLoading = false;
          this.setState(state);
        });
    });
  };

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  componentDidMount() {
    let state = { ...this.state };
    const fieldId = SessionStorageService.getFieldId();
    if (isNullOrEmpty(fieldId)) {
      state.isShowNotExistFieldIdDialog = true;
      this.setState(state);
      return;
    }

    InOutHistoryUserUnregisteredApi.fetchUnidentifiedLogs(
      fieldId,
      InOutHistoryUserUnregisteredService.createSearchUnidentifiedLogParam(
        state.searchForm
      )
    )
      .then(response => {
        if (response.result) {
          state.searchForm.total = response.data.total;
          state.unidentifiedLogsAutoSendFlg =
            response.data.unidentified_logs_auto_send_flg;
          response.data.entities.unidentified_logs.map(it => {
            state.unidentifiedLogs.push(it);

            if (!isNullOrEmpty(it.field_tree_workers)) {
              state.reflectionUnidentifiedLogList.push(it);
              state.reflectionFieldWorkerTreeList.push({
                id: it.id,
                fieldTreeWorkerId:
                  it.field_tree_workers[0].field_tree_worker_id,
              });
            }
            if (
              !isNullOrEmpty(it.field_spot_workers) &&
              !isNullOrEmpty(
                it.field_spot_workers.find(
                  fsp => !isNullOrEmpty(fsp.field_spot_worker_id)
                )
              )
            ) {
              state.reflectionUnidentifiedLogList.push(it);
              state.reflectionFieldSpotWorkerList.push({
                id: it.id,
                fieldSpotWorkerId:
                  it.field_spot_workers[0].field_spot_worker_id,
              });
            }
          });

          if (state.unidentifiedLogs.length > 0) {
            state.searchForm.offset = state.unidentifiedLogs.length;
          }
        } else {
          state = this.showErrorMessageDialog(state, response);
        }
      })
      .catch(error => {
        state = this.showErrorMessageDialog(state, error);
      })
      .finally(() => {
        const { unidentifiedLogs, searchForm } = state;
        state.isLoading = false;
        state.canLoadMore = _.size(unidentifiedLogs) < searchForm.total;
        this.setState(state);
      });

    DocumentDelegate.init();
    this.FormCalendar = new DropdownCalendarLoader();
    this.FormCalendar.constructerQuery = data.calendarClassName;
    this.FormCalendar.init(DocumentDelegate, (event, name, value) => {
      let state = _.cloneDeep(this.state);
      if (name.includes('.')) {
        // editForm.targetDate etc... で送られてくる
        const nameArray = name.split('.');
        if (nameArray[0] === 'searchForm') {
          this.changeSearchDate(nameArray[1], value);
          return;
        }

        state[nameArray[0]][nameArray[1]] = value;
      } else {
        state[name] = value;
      }
      this.setState(state);
    });
    if (this.state.currentSearchParams.clearFlag === true) {
      let stateVal = _.cloneDeep(this.state);
      stateVal.searchForm.clearFlag = false;
      this.setState(stateVal);
    }
  }

  render() {
    return (
      <InOutHistoryUserUnregisteredContext.Provider
        value={{
          state: this.state,
          closeNotExistFieldIdDialog: this.closeNotExistFieldIdDialog,
          // @TODO: 2019/12月リリース時点では検索機能には対応しない
          // selectedRegisterCcusEngineerType: this
          //   .selectedRegisterCcusEngineerType,
          // inputWorkerName: this.inputWorkerName,
          // searchWorkerName: this.searchWorkerName,
          // selectFieldTree: this.selectFieldTree,
          // inputCcusEngineerId: this.inputCcusEngineerId,
          // searchCcusEngineerId: this.searchCcusEngineerId,
          // selectedInOutType: this.selectedInOutType,
          doSearch: this.doSearch,
          searchFormHandle: this.searchFormHandle,
          clearSearchProperty: this.clearSearchProperty,
          selectedSentStatus: this.selectedSentStatus,
          selectedPriorCcusError: this.selectedPriorCcusError,
          checkReflectionData: this.checkReflectionData,
          changeFieldWorkerTree: this.changeFieldWorkerTree,
          changeSort: this.changeSort,
          selectedDeleteItem: this.selectedDeleteItem,
          clearDeleteItem: this.clearDeleteItem,
          infiniteScrollLoad: this.infiniteScrollLoad,
          loadUnidentifiedLogsList: this.loadUnidentifiedLogsList,
          updateUnidentifiedLog: this.updateUnidentifiedLog,
          deleteUnidentifiedLog: this.deleteUnidentifiedLog,
          closeReflectErrorDialog: this.closeReflectErrorDialog,
          closeCsvExportErrorDialog: this.closeCsvExportErrorDialog,
          closeReflectFailedByAlreadyRegisteredErrorDialog: this
            .closeReflectFailedByAlreadyRegisteredErrorDialog,
          closeDialog: this.closeDialog,
          downloadUnidentifiedLogsCsv: this.downloadUnidentifiedLogsCsv,
        }}
      >
        {this.props.children}
      </InOutHistoryUserUnregisteredContext.Provider>
    );
  }
}

const data = {
  calendarClassName: '.sys-form-calender',
  CSV_EXPORT_LIMIT: 3000,
};



// WEBPACK FOOTER //
// ./src/services/inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredStore.js